/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cube-grid': {
    width: 512,
    height: 512,
    viewBox: '0 0 501.536 501.536',
    data: '<path pid="0" d="M118.669 68.985l-93.555 48.354 98.236 47.902 93.645-47.178zM10.768 293.316v105.221l97.449 44.532-.001-104.144zM10.768 143.398v116.598l97.448 45.823V188.925zM138.217 456.803l97.55 44.733.001-103.078-97.551-45.533zM392.678 189.194v116.895l98.09-45.649V142.831zM249.928 101.471l96.837-48.787L250.768 0l-99.531 52.05zM476.558 117.411l-97.892-48.139-95.594 48.58 93.015 46.041zM250.129 134.592l-92.13 46.819 92.769 40.942 90.552-42.235zM265.768 365.354l96.91-45.266V203.194l-96.91 45.265zM392.677 339.194l.001 104.144 98.089-44.801.001-105.148zM138.217 319.819l97.55 45.534V248.459l-97.55-45.534zM265.768 501.536l96.91-44.465V353.194l-96.911 45.266z"/>'
  }
})
